// extracted by mini-css-extract-plugin
export default {"visible":"HamburgerMenu_visible__nDI+o","hidden":"HamburgerMenu_hidden__KLfvH","header":"HamburgerMenu_header__SQj7-","links":"HamburgerMenu_links__pWOCV"};